import React from 'react';
import './App.scss';
// import Layout from 'components/common/Layout';
import { useRoutes } from 'react-router-dom';
// import { Suspense } from 'react';
import useListRouter from 'pages/configs';

function App() {
  const listRouterConfig = useListRouter();

  return <div className="App">{useRoutes(listRouterConfig)}</div>;
}

// function Login() {
//   return <div>Login</div>;
// }

// function Invoices() {
//   return <div>invoices</div>;
// }

// function Activity() {
//   return <div>activity</div>;
// }

export default App;
